var map = {
	"./add_col_after.svg": 12848,
	"./add_col_before.svg": 41615,
	"./add_row_after.svg": 33538,
	"./add_row_before.svg": 95877,
	"./align-center.svg": 93076,
	"./align-left.svg": 50752,
	"./align-right.svg": 69231,
	"./bold.svg": 3462,
	"./checklist.svg": 47593,
	"./code.svg": 43048,
	"./combine_cells.svg": 80084,
	"./delete_col.svg": 30617,
	"./delete_row.svg": 94251,
	"./delete_table.svg": 84711,
	"./edit-line.svg": 79438,
	"./external-link.svg": 839,
	"./font-color.svg": 98606,
	"./github.svg": 97394,
	"./hr.svg": 63865,
	"./image.svg": 83922,
	"./italic.svg": 8083,
	"./link-unlink.svg": 55325,
	"./link.svg": 31119,
	"./mention.svg": 83395,
	"./merge-cells-horizontal.svg": 37810,
	"./ol.svg": 9422,
	"./paragraph.svg": 21679,
	"./quote.svg": 64745,
	"./redo.svg": 52727,
	"./remove.svg": 82315,
	"./split-cells-horizontal.svg": 46585,
	"./strike.svg": 31369,
	"./strikethrough.svg": 37464,
	"./table.svg": 1145,
	"./ul.svg": 23600,
	"./underline.svg": 93081,
	"./undo.svg": 57305
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 46669;